import { render, staticRenderFns } from "./PortalFavoriteMenusDialog.vue?vue&type=template&id=3a52fc30&scoped=true&"
import script from "./PortalFavoriteMenusDialog.vue?vue&type=script&lang=ts&"
export * from "./PortalFavoriteMenusDialog.vue?vue&type=script&lang=ts&"
import style0 from "./PortalFavoriteMenusDialog.vue?vue&type=style&index=0&id=3a52fc30&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3a52fc30",
  null
  
)

export default component.exports